<template>
  <div class="main">
    <div class="title">登记手续</div>

    <div class="content">
      <div>
        <img style="width: 67px;height: 23px;" src="../../assets/corneal/登记手续/登记方式@2x.png" alt />
      </div>
      <div class="mt20 sj">遗体捐献应当遵循自愿、无偿的原则。</div>
      <div class="mt20 sj  mt30">捐献者可在本人户籍所在地或长期居住地就近选择登记机构，办理登记手续。</div>
      <div class="mt10 sj">（1）到登记机构登记；</div>
      <div class="mt10 sj">（2）委托他人代为登记；</div>
      <div class="mt10 sj">（3）登记机构上门登记；</div>
      <div class="mt10 sj">（4）其他便于登记的方式。</div>
      <div class="mt10 sj  mt30">遗体捐献的用途：无偿用于医学教学、医学科研、临床解剖以及角膜移植。</div>
      <div
        class="mt10 sj  mt30"
      >遗体捐献的执行人：可以是捐献人的近亲属或者在工作上、生活上有密切关系的其他自然人，也可以是捐献人生前所在单位、居住地的居（村）民委员会、养老机构或者其他有关单位。</div>
      <div class="mt10  mt30">办理登记手续后，可以变更或撤销。捐献人可以到办理登记的登记机构，办理相关的变更或者撤销手续。</div>

   <div class="mt30">
        <img style="width: 67px;height: 23px;" src="../../assets/corneal/登记手续/捐献流程@2x.png" alt />
      </div>

      <div class="mt20 fr jc ac">
        <img style="width: 266px;height: 379px;" src="../../assets/corneal/登记手续/捐献流程图.png" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  font-size: 12px;

  background-image: url("../../assets/corneal/登记手续/bg.png");
  background-size: cover;
  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;

    padding: 25px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>